import styled, { css } from 'styled-components';
import { themeable } from 'themes/utils';
import { animation } from 'tokens';
import { TextM } from 'ui/Styled/Styled';

export const Container = styled.div`
    display: flex;
    align-items: center;
    flex-flow: row;
    justify-content: center;
    gap: 10px;
`;

export const Label = styled(TextM)<{ $checked: boolean }>`
    transition: all ${animation};
    opacity: ${({ $checked: checked }) => (checked ? 1 : 0.7)};
    cursor: pointer;
`;

export const Switch = styled.div`
    border-radius: 16px;
    width: 52px;
    cursor: pointer;
    padding: 2px;
    background: #161a23;
`;

export const Thumb = styled.button<{ $checked: boolean }>`
    border-radius: 100%;
    background: ${themeable('secondaryBackground')};
    width: 28px;
    height: 28px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: inherit;
    box-shadow:
        0px 3px 1px 0px rgba(0, 0, 0, 0.06),
        0px 3px 8px 0px rgba(0, 0, 0, 0.15);
    position: relative;
    transition: all ${animation};

    ${({ $checked }) =>
        $checked
            ? css`
                  margin-left: 20px;
              `
            : css`
                  margin-right: 20px;
              `}
`;

export const ThumbContent = styled.div<{ $checked: boolean }>`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    transform: all ${animation};

    opacity: ${({ $checked }) => ($checked ? 1 : 0)};
`;
